"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadDocumentCommand = void 0;
var tslib_1 = require("tslib");
var control_1 = require("../../../core/model/options/control");
var command_base_1 = require("../command-base");
var command_states_1 = require("../command-states");
var print_document_command_1 = require("./print-document-command");
var DownloadDocumentCommand = (function (_super) {
    tslib_1.__extends(DownloadDocumentCommand, _super);
    function DownloadDocumentCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DownloadDocumentCommand.prototype.getState = function () {
        return new command_states_1.SimpleCommandState(this.isEnabled());
    };
    DownloadDocumentCommand.prototype.executeCore = function (_state, options) {
        this.control.serverDispatcher.forceSendingRequest();
        this.control.owner.sendDownloadRequest(print_document_command_1.DownloadRequestType.DownloadCurrentDocument, JSON.stringify({
            "fileName": options.param.fileName,
            "documentFormat": options.param.documentFormat
        }));
        return true;
    };
    DownloadDocumentCommand.prototype.isEnabled = function () {
        return _super.prototype.isEnabled.call(this) && control_1.ControlOptions.isEnabled(this.control.modelManager.richOptions.control.download) &&
            this.control.modelManager.model.isLoaded();
    };
    DownloadDocumentCommand.prototype.isEnabledInReadOnlyMode = function () {
        return true;
    };
    return DownloadDocumentCommand;
}(command_base_1.CommandBase));
exports.DownloadDocumentCommand = DownloadDocumentCommand;
